import Head from 'next/head';

interface LongtailJsonLdProps {
  jsonLd: string;
}

export const LongtailJsonLd = ({ jsonLd }: LongtailJsonLdProps) => {
  return (
    <Head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: jsonLd }} />
    </Head>
  );
};
